import { useIntl } from 'react-intl';
import { FSEAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { commonMessages } from '../../messages';

const dashBoardMessages = commonMessages.dashboard;
const menuMessages = commonMessages.menu;

export const useServiceInformationLinks = () => {
  const launchDarkly = useLaunchDarkly();
  const externalLinks = launchDarkly['config-web-app']?.ecosystem?.externalLinks;
  if (!externalLinks || !launchDarkly['smart-farming-enabled-web-global']) {
    return undefined;
  }
  const brands = ['fendt', 'valtra', 'massey'] as const;
  return brands.reduce(
    (all, item) => {
      return {
        ...all,
        [item]: launchDarkly[`smart-farming-enabled-web-${item}`] ? externalLinks[item] : '',
      };
    },
    {} as { [brand in (typeof brands)[number]]: string },
  );
};

export const useManualsTitleDescUrl = () => {
  const { formatMessage } = useIntl();
  const launchDarkly = useLaunchDarkly();
  const isRepairManualsEnabled = launchDarkly['repair-manuals-enabled'] ?? false;

  return {
    manualsTitle: isRepairManualsEnabled
      ? formatMessage(menuMessages.manuals)
      : formatMessage(dashBoardMessages.manualsTitle),
    manualsDescription: isRepairManualsEnabled
      ? formatMessage(dashBoardMessages.manualsDescription2)
      : formatMessage(dashBoardMessages.manualsDescription),
    manualsUrl: isRepairManualsEnabled
      ? `${FSEAuthRoutes.SERVICE_AND_INFORMATION}/search-manuals`
      : `${FSEAuthRoutes.SERVICE_AND_INFORMATION}/find-manuals`,
  };
};
